export const texts = [
  // Terrain
  {
    type: "MultiLineText",
    group: "terrain",
    x: 318,
    y: 66,
    text: ["PHANG NGA"],
    style: { fill: "#606769" }
  },
  {
    type: "MultiLineText",
    group: "terrain",
    textAnchor: "start",
    x: 258,
    y: 329,
    text: ["THEPKASATTRI RD."],
    style: { fill: "#434a69" }
  },
  {
    type: "MultiLineText",
    group: "terrain",
    textAnchor: "end",
    x: 211,
    y: 424,
    text: ["BAN DON", "CHERNG", "TALAY RD."],
    style: { fill: "#434a69" }
  },
  {
    type: "MultiLineText",
    group: "terrain",
    textAnchor: "start",
    x: 192,
    y: 471,
    text: ["SRISOONTHORN RD."],
    style: { fill: "#434a69" }
  },
  {
    type: "MultiLineText",
    group: "terrain",
    textAnchor: "end",
    x: 171,
    y: 115,
    text: ["SARASIN BRIDGE"],
    style: { fill: "#41d3ab" }
  }
];

export const CNtexts = [
  // Terrain
  {
    text: ["攀牙"],
  },
  {
    text: ["Thepkasattri路"],
  },
  {
    text: ["Ban Don", "Cherng", "路"],
  },
  {
    text: ["Srisoonthorn路"],
  },
  {
    text: ["萨拉辛桥"],
  }
];

export const RUtexts = [
  // Terrain
  {
    text: ["Пхангнга (Phang Nga)"],
  },
  {
    text: ["Дорога Тепкасатри (Thepkasattri Road)"],
  },
  {
    text: ["Дорога","Ban Don", "Cherng","Talay RD."],
  },
  {
    text: ["Дорога Срисунтхорн (Srisoonthorn Road)"],
  },
  {
    text: ["Мост Сарасин (Sarasin)"],
  }
];


// WEBPACK FOOTER //
// ./src/containers/PhuketMap/common.js